import Popup from "reactjs-popup";
import React, { Component } from "react";
import icons from "../../helpers/iconMenu";
import subscribersService from "./api/subscribersApi";
import Form from '../../components/form-component/form';
import { getStaticText } from '../../lables/lablesService';
import Table from '../../components/table-data-component/table';
import Spinner from '../../components/spinner-component/Spinner';

import '../../scss/os-global.scss';
import 'reactjs-popup/dist/index.css';

class Subscribers extends Component {

  constructor(props) {
    super(props);

    this.DataService = subscribersService;
    this.rows = [];
    this.page = 1;
    this.per_page = 10;
    this.all_pages = 0;
    this.order = { 'id': "DESC" };

    this.form_info = {};
    this.empty_form_info = {
      'id': 0,
      'name': '',
      'email': '',
      'active': 1
    };

    this.state = {
      'has_data': false,
      'show_popup': false
    };
  }

  async changePage(page_number = 1) {
    this.page = page_number;
    await this.getDataList();
  }

  async changeOrder(new_order = {}) {
    this.order = new_order;
    await this.getDataList();
  }

  openAddNewForm() {
    this.form_info = {};
    Object.assign(
      this.form_info,
      this.empty_form_info
    );
    this.popupToggle();
  }

  openEditForm(row_for_edit = {}) {
    this.form_info = {};
    Object.assign(
      this.form_info,
      row_for_edit
    );
    this.popupToggle();
  }

  popupToggle() {
    this.setState({
      'show_popup': !this.state.show_popup
    });
  }

  async getDataList() {
    this.setState({ 'has_data': false });

    let list_response = await this.DataService.s_list({
      'page': this.page,
      'per_page': this.per_page,
      'order': this.order
    });

    if (typeof (list_response.rows) !== 'undefined') {
      this.rows = list_response.rows;
      this.all_pages = list_response.all_pages;
    }

    this.setState({ 'has_data': true });
  }

  async saveCallback(info_from_form = {}) {
    let saved = null;

    if (this.form_info.id) {
      saved = await this.DataService.s_update(info_from_form);
    } else {
      saved = await this.DataService.s_add(info_from_form);
    }

    if (!saved) {
      window.alert(getStaticText('save_error'));
    } else {
      window.alert(getStaticText('save_success'));
      this.page = 1;
      this.popupToggle();
      await this.getDataList();
    }
  }

  async deletePost(post_for_delete) {

    if (!window.confirm(getStaticText('remove_confirm_text')))
      return false;

    let result = await this.DataService.s_remove(post_for_delete.id);

    if (!result) {
      window.alert(getStaticText('remove_error'));
    } else {
      window.alert(getStaticText('remove_success'));
      this.page = 1;
      this.getDataList();
    }
  }

  async componentDidMount() {
    await this.getDataList();
  }

  render() {
    let content = null;

    if (!this.state.has_data) {
      content = (
        <div className="col-lg-12 text-center">
          <Spinner />
        </div>
      );
    } else {
      content = (
        <>
          <div className="col-lg-12 os-text-right">
            <button
              className="btn btn-success text-white"
              onClick={this.openAddNewForm.bind(this)}
            >
              {getStaticText('s_add_new_popup_title')}
            </button>
          </div>

          <Popup
            className="os-popup"
            closeOnEscape={false}
            open={this.state.show_popup}
            closeOnDocumentClick={false}
          >
            <>
              <div className="os-popup-header">
                <span className="op-popup-title">
                  {this.form_info.id ? getStaticText('s_edit_popup_title') : getStaticText('s_add_new_popup_title')}
                </span>
                <button
                  className="os-popup-close-button"
                  onClick={this.popupToggle.bind(this)}
                >
                  <i className={icons.news_remove_icon} />
                </button>
              </div>

              <div className="os-popup-body">
                <Form
                  info={this.form_info}
                  sections={{
                    'rtac_form': {
                      'fields': {
                        'name': {
                          'type': 'input_text',
                          'name': 'name',
                          'label': getStaticText('s_add_form_name')
                        },
                        'email': {
                          'type': 'input_email',
                          'name': 'email',
                          'label': getStaticText('s_add_form_email')
                        },
                        'active': {
                          'type': 'input_checkbox',
                          'name': 'active',
                          'label': getStaticText('s_add_active')
                        }
                      }
                    }
                  }}
                  saveInfoCallback={this.saveCallback.bind(this)}
                  buttonLabel={this.form_info.id ? getStaticText('s_btn_update') : getStaticText('s_btn_add')}
                />
              </div>
            </>
          </Popup>

          <div className="col-lg-12 pt-3">
            <Table
              currentOrder={this.order}
              changeOrderCallback={this.changeOrder.bind(this)}
              header={{
                'id': {
                  'label': getStaticText('s_id_table'),
                  'sortButton': true
                },
                'name': {
                  'label': getStaticText('s_name_table'),
                  'sortButton': true
                },
                'email': {
                  'label': getStaticText('s_email_table'),
                  'sortButton': true
                },
                'active': {
                  'label': getStaticText('s_active_table'),
                  'sortButton': true
                },
                'action': {
                  'label': getStaticText('s_action_table'),
                  'sortButton': false
                }
              }}
              body={[
                (row) => { return row.id; },
                (row) => { return row.name; },
                (row) => { return row.email; },
                (row) => { return row.active ? getStaticText('s_active_yes') : getStaticText('s_active_no'); },
                (row) => {
                  return (<>
                    <button
                      onClick={this.openEditForm.bind(this, row)}
                      title={getStaticText('s_edit_button_title')}
                      className="btn btn-sm btn-info text-white os-mr-1"
                    >
                      <span className={icons.news_edit_icon} />
                    </button>
                    <button
                      onClick={this.deletePost.bind(this, row)}
                      className="btn btn-sm btn-danger text-white"
                      title={getStaticText('s_delete_button_title')}
                    >
                      <span className={icons.news_trash_icons} />
                    </button>
                  </>);
                }
              ]}
              rows={this.rows}
              page={this.page}
              allPages={this.all_pages}
              changePageCallback={this.changePage.bind(this)}
              emptyRowsMessage={getStaticText('s_list_empty')}
            />
          </div>

        </>
      );
    }
    return (
      <div className="row">
        <div className="col-lg-12">
          <h2>{getStaticText('s_title')}</h2>
        </div>
        {content}
      </div>
    );
  }

}

export default Subscribers;